module.exports = __webpack_public_path__ + "img/selected.fd97ac7c.svg";